/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import RelatedContent from '@msr/components/Card/RelatedContent';
import MsrTopBanner from '@msr/components/HeaderBanner/MsrTopBanner';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import StructuredTextContent from '@msr/components/UI/StructuredTextContent';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 *
 * @param {Object} pageData
 * @returns
 */
const PowerOfMantraLang = ({ pageData, lang }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang('', lang);
  }, [authContext, '', lang]);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {pageData?.breadcrumbs?.length > 0 && (
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={''}
          lang={lang}
        />
      )}
      <Box as="section" className="container-article" p="0" bg="#FFF7E9">
        <MsrTopBanner
          sectionContent={{
            title: pageData.title,
            style: 'default',
            mobileImages: pageData.heroImage,
            desktopImage: [pageData.heroImage],
          }}
        />
        <Box
          maxW="586px"
          mx="auto"
          py={{ base: '20px', md: '60px' }}
          px="15px"
          className="structured-content-dark"
        >
          {StructuredTextContent(pageData.body)}
        </Box>
        {pageData?.related_content && (
          <RelatedContent posts={pageData?.related_content} lang={lang} />
        )}
      </Box>
      <PageConfig
        isLikeVisible={false} pageData={pageData}
      />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
      `/mahashivratri/kn/shiva/power-of-the-mantra`,
    ]
    : await getLandingPaths('L2', '/shiva/power-of-the-mantra/', 'shiva_section');
  return {
    paths: msrPaths,
    fallback: false
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { lang }
}) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', lang, 'msr'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('', lang, 'msr'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', lang, `shiva/power-of-the-mantra`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      lang: lang,
      menuType: 'msrmainmenu'
    }
  };
};

export default PowerOfMantraLang;
